















































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import OverlayWindow from "../general/OverlayWindow.vue";
import Loading from "../general/Loading.vue";

import { ClientMailingJson } from "../../shared/ClientJson";
import MailingRecipientJson from "../../shared/MailingRecipientJson";
import { MailingRecipientStatus, MailingRecipientStatusNames } from "../../shared/MailingRecipientStatus";

import { UserPermissionRank } from "../../shared/UserPermissionRank";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

export default Vue.extend({
  name: "MailingsMessageDetailsRecipientSelect",
  components: {
    OverlayWindow,
    Loading,
    TableView,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    selectedIndex: Number,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      MailingRecipientStatus: MailingRecipientStatus,
      MailingRecipientStatusNames: MailingRecipientStatusNames,
      detailsTitle: "",
      UserPermissionRank: UserPermissionRank,
      allConfirmedRecipients: null as ClientMailingJson[] | null,
      recipientsMoreAvailable: null as boolean | null,
      hasChanges: false,
      loadingGeneral: false as boolean,
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      this.loadConfirmedRecipients();
    },

    async loadConfirmedRecipients(loadMore: null = null) {
      var skipAmount = null as number | null;

      //load more
      if (loadMore && this.allConfirmedRecipients != null) {
        this.recipientsMoreAvailable = null;
        skipAmount = this.allConfirmedRecipients.length;
      } else {
        this.allConfirmedRecipients = null;
      }

      //final load recipients
      if (this.restClient != null) {
        try {
          let recipients = await this.restClient.getMailingRecipients(
            [MailingRecipientStatus.confirmed, MailingRecipientStatus.unreachable],
            null,
            null,
            null,
            skipAmount
          );

          if (loadMore && this.allConfirmedRecipients != null) {
            this.allConfirmedRecipients = this.allConfirmedRecipients.concat(recipients.mailingRecipients);
          } else {
            this.allConfirmedRecipients = recipients.mailingRecipients;
          }

          this.recipientsMoreAvailable = recipients.moreAvailable;
        } catch (e) {
          alert(e.message);
        }
      }
    },

    //START set cached data

    //END set cached data

    closeDetails() {
      if (!this.hasChanges) {
        this.$emit("closeOverlay");
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          this.$emit("closeOverlay");
        } else {
          //do nothing
        }
      }
    },

    //START set input data (where data be cached)

    //END set input data (where data be cached)

    //tableView
    tableViewButtonClicked(button: string, item: any) {
      if (button == "selectRecipient") {
        this.$emit("itemSelected", item, this.selectedIndex);
        this.$emit("closeOverlay");
      }
    },

    tableViewItemClicked(item: any) {
      this.$emit("itemSelected", item, this.selectedIndex);
      this.$emit("closeOverlay");
    },
  },

  watch: {
    recipientDetails: {
      handler(val, oldVal) {
        if (oldVal != null) {
          this.hasChanges = true;
        }
      },
      deep: true,
    },
  },

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    recipientColumns: function (): TableViewColumnDefinitions<ClientMailingJson>[] {
      let vue = this;

      return [
        {
          th: "Vorame",
          td: (i) => (i.contact != null && i.contact.firstName != "" ? i.contact.firstName : "--"),
        },
        {
          th: "Nachname",
          td: (i) => (i.contact != null && i.contact.lastName != "" ? i.contact.lastName : "--"),
        },
        {
          th: "E-Mail",
          td: (i) => (i.contact != null ? i.contact.email : "--"),
        },
        {
          th: "Status",
          td: (i) => vue.MailingRecipientStatusNames[i.mailingRecipient!.state],
        },
        {
          th: "",
          td: (i) => "Auswählen",
          style: (i) => "text-align:right",
          button: "selectRecipient",
        },
      ] as TableViewColumnDefinitions<ClientMailingJson>[];
    },
  },
});
